import React from "react";

function ServiceItem(props) {
  const getNumItemsInCategory = (categoryTitle) => {
    if (categoryTitle === "All Categories") {
      return props.services.length;
    }
    return props.services.filter((item) => item.category === categoryTitle)
      .length;
  };

  return (
    <button
      style={{ width: "220px", height: "80px" }}
      className="mr-8 ml-2 rounded-lg outline-none border border-primary pl-8 pr-8 flex justify-center items-center pt-3 pb-3"
    >
      <img
        className="pr-3 pl-3"
        src={props.serviceItem.img}
        width="70px"
        alt="category"
      />
      <div className="flex flex-col justify-center items-center">
        <h3 className="pr-4 font-semibold">{props.serviceItem.title}</h3>
        <h3 className="pr-4 text-primary">
          ({getNumItemsInCategory(props.serviceItem.title)} services)
        </h3>
      </div>
    </button>
  );
}

export default ServiceItem;
